import { useState } from "react";

import { getState } from "../../state/store";
import { selectDeviceByCodentify } from "../../state/selectors";

import { strCode } from "../../consts";
import { fleetManagementService, notificationService, t } from "../../services";
import { fleetManagementUtil } from "../../utils";

export const useCreateDeviceKit = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const mutationCallback = async (kitData, deviceCodentify) => {
    setLoading(true);
    setError(false);

    let relatedDusn = null;

    try {
      if (kitData) {
        const { kitCodentify, relatedCodentify, relatedKitCodentify } = kitData;
        relatedDusn = selectDeviceByCodentify(
          relatedCodentify ? relatedCodentify : deviceCodentify
        )(getState())?.dusn;

        const kitDataPromises = [];

        if (kitCodentify) {
          kitDataPromises.push(
            fleetManagementService.createDeviceKit({
              device_codentify: deviceCodentify,
              device_kit_codentify: kitCodentify
            })
          );
        }

        if (relatedCodentify && relatedKitCodentify) {
          kitDataPromises.push(
            fleetManagementService.createDeviceKit({
              device_codentify: relatedCodentify,
              device_kit_codentify: relatedKitCodentify
            })
          );
        }

        await Promise.all(kitDataPromises);
      }
    } catch (err) {
      setError(true);

      notificationService.showError({
        title: t(strCode.CREATE_DEVICE_KIT_ERROR),
        message: t(
          fleetManagementUtil.parseDeviceErrorMessage(
            err?.response?.data?.error ? err?.response?.data?.error : err?.toString()
          ),
          { relatedDusn }
        )
      });
    } finally {
      setLoading(false);
    }
  };

  return { mutationCallback, loading, error };
};
